export const locale = {
  lang: 'es',
  data: {
    'SHEDULE': {
      'ALERT': '¿Desea continuar con el envío?',
      'TITLE1': 'Registre fecha de lanzamiento: ',
      'TITLE2': 'Registre recordatorio: ',
      'TITLE3': 'Registre cierre: ',
      'SELECT_DATE': 'Seleccione una fecha',
      'SELECT_DATEPCIKER':'Seleccione una fecha',
      'SAVE': 'Guardar',
      'RECORDATORIOS': 'Recordatorios: ',
      'FECHA': 'Fecha: ',
      'AGREGAR': 'Agregar',
      'EDITAR': 'Editar',
      'COMPLETAR_PASO': 'Completar paso',
      'PASO_COMPLETADO': 'Paso completado',
      'ERROR1': 'La fecha no puede ser menor a la actual',
      'ERROR2': 'La fecha debe ser al menos 30 días superior a la actual',
      'ERROR3':'¿Seguro que desea continuar?',
      'ERROR4':'Para que los colaboradores reciban el plan de comunicación completo, es necesario que programe la encuesta con al menos 30 días de anticipación.',
      'MSJ1':'¡Advertencia!',
      'MSJ2':'Si continúa no podrá revertir la fecha de lanzamiento. ',
      'MSJ3':'Sí',
      'MSJ4':'Aún no ha programado una fecha',
      'MSJ5':'Se ha programado la encuesta',
      'MSJ6':'La encuesta ha sido creada',
      'MSJ7':'El paso ha sido completado',
      'MSJ8':'Cancelar',
      'MSJ9':'Aún no se ha creado la encuesta',
      'MSJ10':'Aún no se ha guardado una fecha de lanzamiento',
      'MSJ11':'Los recordatorios no pueden enviarse después de la fecha de cierre de la encuesta.',
      'MSJ12':'Todos los colaboradores han fanalizado la encuesta',
      'MSJ13':'Recordatorio registrado',
      'MSJ14':'Los recordatorios no pueden enviarse antes de la fecha de lanzamiento.',
      'MSJ15':'Advertencia solo te queda un recordatorio',
      'ERROR5':'Sí',
      'LANZAMIENTO': 'La encuesta comenzará el: ',
      'AVISO1': 'Primer aviso',
      'AVISO2': 'Segundo aviso',
      'AVISO3': 'Tercer aviso',
      'CIERRE':'La encuestas finaliza el:',
      'RESULTADOS':'Los resultados se publicarán el día:',
      'SURVEY':'Creando encuesta',
      'MAS50':'Creando encuesta más de 50',
      'MENOS':'Creando encuesta menos de 50',
      'SUCCESS_MAS50':'!Encuesta de más de 50 colaboradores creada correctamente!',
      'SUCCESS_MENOS':'!Encuesta de menos de 50 colaboradores creada correctamente!',
      'USERS':'Creando usuarios',
      'ENCUESTA':'Creando encuesta',
      'BTNSURVEY':'Crear encuesta',
      'REMAINDER':{
        'REMAINDER1':'Recordatorio 30 días antes de la encuesta: ',
        'REMAINDER2':'Recordatorio 15 días antes de la encuesta: ',
        'REMAINDER3':'Lanzamiento de la encuesta: ',
        'REMAINDER4':'Cierre de la encuesta: ',
        'REMAINDER5':'Resultados: ',
        'REMAINDER51':'Recordatorio ',
        'REMAINDER6':'Recordatorio 29 días antes de la encuesta: ',
        'REMAINDER7':'Recordatorio 7 días antes de la encuesta: ',
      }

    },
  }
};
